import { Component, effect, EventEmitter, Input, Output, signal } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Plan } from 'src/app/models/plan.model';
import { v4 as uuidv4 } from 'uuid';
import { AssemblyPricesService } from '../assembly-editor/assembly-prices.service';
import { ToolbarModule } from 'primeng/toolbar';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { PlanSelectorComponent } from '@/landmark/operations/plan-selector/plan-selector.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { AssembliesService } from '@/services/api/assemblies.service';
import { AssemblyPriceTable } from '@/models/assembly.model';
import { PlansService } from '@/services/api/plans.service';
import { TooltipModule } from 'primeng/tooltip';


@Component({
    selector: 'app-assembly-price-list',
    imports: [
        ToolbarModule,
        TableModule,
        ButtonModule,
        DialogModule,
        PlanSelectorComponent,
        CommonModule,
        FormsModule,
        SelectModule,
        InputTextModule,
        MessageModule,
        ConfirmPopupModule,
        TooltipModule
    ],
    template: `
    <div>
            <!-- <p-toolbar styleClass="mb-2">
                <ng-template pTemplate="left">
                    <span class="text-xl font-bold">Assembly Price List</span>
                </ng-template>
              
                <ng-template pTemplate="right">
                    <p-button type="button" [label]="'Add Exception'" icon="pi pi-plus" (onClick)="toggleAddNew()"  />
                </ng-template>
            </p-toolbar> -->
            <p-table 
            [value]="assemblyPricesService.assemblyPrices()" 
            stripedRows
            [scrollable]="true"
            scrollHeight="50vh"
            editMode="row"
            dataKey="PlanID"
            size="small"
            styleClass="mt-2"
            >
            <ng-template #caption>
        <div class="flex">
        <span class="text-xl font-bold">Assembly Price List</span>
        <p-button type="button" [label]="'Add Exception'" icon="pi pi-plus" (onClick)="toggleAddNew()" class="ml-auto"/>
        </div>
    </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>Plan</th>
                    <th>Price</th>
                    <th></th>
                </tr>
            </ng-template>
                <ng-template pTemplate="body" let-price let-ri="rowIndex" let-editing="editing">
                    <tr>
                        <td  class="text-right">
                                    {{ price.Plans.PlanName }}
                            </td>
                        <td *ngIf="!price.Type" style="width:25%" [pEditableColumn]="price">
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input 
                                        pInputText type="number" 
                                        [(ngModel)]="price.Price" 
                                        required />
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{price.Price | currency:'USD':'symbol':'1.2-2'}}
                                </ng-template>
                            </p-cellEditor>
                        </td>
                        <td *ngIf="price.Type" class="text-danger" style="width:25%">Excluded</td>
                        <td>
                            <div class="flex align-items-center justify-content-end gap-2">   
                            <button 
                                    *ngIf="price.PlanID !== 1"
                                    pButton 
                                    pRipple 
                                    type="button" 
                                    icon="pi pi-exclamation-triangle" 
                                    pTooltip="Exclude this plan from the assembly price list. Useful if price is set to all plans, but you need to exclude this plan completely."
                                    (click)="toggleExclude($event, price)" 
                                    class="p-button-rounded p-button-text p-button-warn ml-auto"
                                    >
                                </button>          
                                <button 
                                    pButton 
                                    pRipple 
                                    type="button" 
                                    icon="pi pi-trash" 
                                    (click)="confirmRemove($event, price)" 
                                    class="p-button-rounded p-button-text p-button-danger ml-auto">
                                </button>
                            </div>
                                </td>
                    </tr>
                </ng-template>
        </p-table>
        </div>
<p-confirmPopup>
    <ng-template pTemplate="content" let-message>
        <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border p-3 mb-3">
            <i [class]="message.icon" class="text-6xl text-primary-500"></i>
            <p>{{ message.message }}</p>
        </div>
    </ng-template>
</p-confirmPopup>
<p-dialog appendTo="body" header="Add Plans" [modal]="true" [draggable]="false" [resizable]="false" [(visible)]="addVisible" [style]="{ overflowY: 'auto', 'max-height': '90vh' }">
<app-plan-selector [multiple]="true" [priceMode]="true" (selectedPlansChange)="onSelectPlans($event)" [filterPlanIds]="usedPlanIds"></app-plan-selector>
</p-dialog>
    `
})
export class AssemblyPriceListComponent {
  plans: Plan[] = [];
  usedPlanIds: number[] = [];
  addVisible: boolean = false;
  @Output() onSave = new EventEmitter<AssemblyPriceTable>();
  @Output() onRemove = new EventEmitter<AssemblyPriceTable>();

  constructor(
    private messageService: MessageService,
    public selectedAssemblyService: AssembliesService,
    public plansDataService: PlansService,
    private confirmationService: ConfirmationService,
    public assemblyPricesService: AssemblyPricesService
    
  ) {
    
  effect(() => {
    const assembly = this.selectedAssemblyService.selectedAssembly();
    if(assembly) {
      this.usedPlanIds = assembly.AssemblyPriceTable.map(p => p.PlanID);
    }
  });
  effect(() => {
    const plans = this.plansDataService.allPlansData();
    if(plans.length > 0) {
      this.plans = plans;
    }
  });
  }

  toggleAddNew() {
    this.addVisible = true;
}

confirmRemove(event: any, price: AssemblyPriceTable) {
  this.confirmationService.confirm({
    target: event.target as EventTarget,
    message: 'Are you sure you want to remove this price?',
    accept: () => this.onPriceRemove(price)
  });
}

  onPriceRemove(price: AssemblyPriceTable) {
    if(price.APID > 0) {
      this.assemblyPricesService.addToRemovedPrices(price);
      this.assemblyPricesService.assemblyPrices.set(this.assemblyPricesService.assemblyPrices().filter(p => p.APID !== price.APID));
    } 
      this.assemblyPricesService.removeAssemblyPrice(price);
      
  }

  toggleExclude(event: any, price: AssemblyPriceTable) {
    price.Type = !price.Type;
  }

  onSavePriceList() {
    this.onSave.emit();
    this.addVisible = false;
  }

  onCancelPriceList() {
    this.addVisible = false;
  }

  onRowEditInit(priceItem: AssemblyPriceTable) {
    const key = this.getUUID();
    // Create a deep copy of the price item
    const clonedItem = { ...priceItem };
    this.assemblyPricesService.updateSpecificClone(clonedItem, key);
}


onRowEditSave(priceItem: AssemblyPriceTable, index: number) {
  const plan = this.plans.find(p => p.PlanID === priceItem.PlanID);
  if (plan) {
      priceItem.Plans = plan;
  }
  
  // Update the array using the signal's update method
  this.assemblyPricesService.assemblyPrices.update(prices => {
      const newPrices = [...prices];
      if (index >= 0) {
          newPrices[index] = priceItem;
      }
      return newPrices;
  });
  
  // Clear the cloned prices for this item
  this.assemblyPricesService.clonedPrices.update(cloned => {
      const newCloned = { ...cloned };
      const key = Object.keys(newCloned).find(k => 
          JSON.stringify(newCloned[k]) === JSON.stringify(priceItem)
      );
      if (key) {
          delete newCloned[key];
      }
      return newCloned;
  });
  
}

onRowEditCancel(priceItem: AssemblyPriceTable, index: number) {
  this.assemblyPricesService.assemblyPrices.update(prices => {
      const newPrices = [...prices];
      const key = Object.keys(this.assemblyPricesService.clonedPrices()).find(k => 
          JSON.stringify(this.assemblyPricesService.clonedPrices()[k]) === JSON.stringify(priceItem)
      );
      if (key) {
          newPrices[index] = this.assemblyPricesService.clonedPrices()[key];
      }
      return newPrices;
  });

  // Clear the cloned prices
  this.assemblyPricesService.clonedPrices.update(cloned => {
      const newCloned = { ...cloned };
      const key = Object.keys(newCloned).find(k => 
          JSON.stringify(newCloned[k]) === JSON.stringify(priceItem)
      );
      if (key) {
          delete newCloned[key];
      }
      return newCloned;
  });
}

getUUID() {
  return uuidv4();
}

onSelectPlans(event: {plans: Plan[], price: number}) {
  const assembly = this.selectedAssemblyService.selectedAssembly();
  console.log(event);
  for(let plan of event.plans) {
    this.assemblyPricesService.assemblyPrices().push(new AssemblyPriceTable({
      PlanID: plan.PlanID,
      Price: event.price,
      Type: false,
      AID: assembly?.AID ?? 0,
      APID: 0,
      FID: assembly?.FID ?? 0,
      Plans: plan
    }));
  }
  this.addVisible = false;
}

}
